(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["facebook-feed"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('atelier-facebook-feed')) {
    customElements.define('atelier-facebook-feed', class extends HTMLElement {
      connectedCallback() {
        this.observer = new ResizeObserver(() => {
          clearTimeout(this.resizeTimer);
          this.resizeTimer = setTimeout(() => this.resizeFeed(), 200);
        });
        this.observer.observe(this);
        this.resizeFeed();
      }
      resizeFeed() {
        const width = Math.min(500, Math.floor(this.getBoundingClientRect().width));
        if (width < 180 || this.feedWidth === width) return;
        this.feedWidth = width;
        const frame = this.querySelector('iframe');
        const url = new URL(frame.src);
        url.searchParams.set('width', width);
        frame.width = width;
        frame.src = url.href;
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        clearTimeout(this.resizeTimer);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
